// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2njci","dragIcon":"SortableItem_dragIcon__2-VOI","disabled":"SortableItem_disabled__2HTcC"};